import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { session, loading, onboardingCompleted } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Redirect to onboarding if profile not completed (but not if already on onboarding/change-password)
  if (
    onboardingCompleted === false &&
    location.pathname !== "/onboarding" &&
    location.pathname !== "/change-password" &&
    location.pathname !== "/terms"
  ) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
